<div class="recommendation-container">
    <div class="recommendation-detail-container">
        <div class="flex items-baseline gap-2 mb-4">
            <span class="text-[16px] font-bold text-[var(--base-text-dark)]">Interpretation:</span>
            <span class="text-[15px] font-medium text-[var(--base-text-alt-dark)]">{{recommendationDetails?.recommendationId ?? '-'}}</span>
        </div>

        <span class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2">General Details</span>

        <div class="flex flex-wrap gap-x-1 gap-y-1 text-[13px] items-center">
            <div class="div-row">
                <span style="font-weight: 700">Date Interpreted:&nbsp;</span>
                <span>{{recommendationDetails?.creationDate ? ( recommendationDetails.creationDate | date:'yyyy-MM-dd') : '-'}}</span>
                <div class="vertical-line"></div>
            </div>

            <div class="div-row">
                <span style="font-weight: 700">Date Completed:&nbsp;</span>
                <span>{{recommendationDetails?.completedDate ? ( recommendationDetails.completedDate | date:'yyyy-MM-dd') : '-'}}</span>
                <div class="vertical-line"></div>
            </div>

            <div class="div-row">
                <span style="font-weight: 700">Interpreted By:&nbsp;</span>
                <span>{{recommendationDetails?.creationUser?.name + " " + recommendationDetails?.creationUser?.surname}}</span>
                <div class="vertical-line"></div>
            </div>

            <div class="div-row">
                <span style="font-weight: 700">Agronomist:&nbsp;</span>
                <span>{{recommendationDetails?.agronomistUser?.name && recommendationDetails?.agronomistUser?.surname ? recommendationDetails.agronomistUser.name + ' ' + recommendationDetails.agronomistUser.surname : '-'}}</span>
                <div class="vertical-line"></div>
            </div>

            <div class="div-row">
                <span style="font-weight: 700">Client:&nbsp;</span>
                <span>{{recommendationDetails?.otcCustomerDetail?.name ?? '-'}}</span>
                <div class="vertical-line"></div>
            </div>

            <div class="div-row">
                <span style="font-weight: 700">Type:&nbsp;</span>
                <span>{{recommendationDetails?.recManTypes?.description ?? '-'}}</span>
            </div>
        </div>
    </div>

    <div class="h-px bg-[var(--app-base)] my-5"></div>

    <span class="section-title">Lab Results</span>

    <div class="flex items-center justify-between gap-2.5 flex-wrap mb-2">
        <div class="relative">
            <span class="material-icons absolute left-2.5 top-1/2 -translate-y-1/2 text-[18px] text-[var(--tertiary-text)]">search</span>
            <input type="text" placeholder="Search..." [(ngModel)]="searchText" (ngModelChange)="emitSearchChanges()"
                class="py-2 pl-9 pr-3 border-[1.5px] border-[var(--app-border)] rounded-lg text-[13px] w-[200px] outline-none transition-colors bg-[var(--app-base)] focus:border-[var(--primary-dark)] text-[var(--base-text-alt-dark)]">
        </div>

        <button (click)="showNorm = !showNorm"
            class="py-1.5 px-4 border-none rounded-lg text-[12px] font-semibold bg-[var(--primary-dark)] text-white cursor-pointer flex items-center gap-1.5 hover:opacity-90 transition-all">
            Toggle Norms
        </button>
    </div>

    <div class="table-container">
        <div class="sample-table">
            <table mat-table [dataSource]="sampleSource">

                <ng-container matColumnDef="farm">
                    <th mat-header-cell class="mat-cell-header recommendations-manager-top-left-cell" *matHeaderCellDef> Farm </th>
                    <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.pinSamples?.pin?.field?.farm?.name ?? '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="field">
                    <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Field </th>
                    <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.pinSamples?.pin?.field?.name ?? '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="sample">
                    <th mat-header-cell *matHeaderCellDef class="mat-cell-header"> Sample </th>
                    <td mat-cell *matCellDef="let element"> {{element?.pinSamples?.name ?? '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="sampleDate">
                    <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Sample Date </th>
                    <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.pinSamples?.creationDate ? (element.pinSamples.creationDate | date:'yyyy-MM-dd') : '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="labReference">
                    <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Lab Ref</th>
                    <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.submission?.submissionId ?? '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="labDate">
                    <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Lab Date </th>
                    <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.submission?.creationDate ? (element.submission.creationDate | date:'yyyy-MM-dd') : '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="crop">
                    <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Crop </th>
                    <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.crop?.description ?? '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="region">
                    <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Region </th>
                    <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.norm?.regionDescription ?? '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="growthStage">
                    <th mat-header-cell class="mat-cell-header" *matHeaderCellDef> Sampling Period </th>
                    <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.norm?.description ?? '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="cultivar">
                    <th mat-header-cell *matHeaderCellDef class="mat-cell-header samples-top-right-cell"> Cultivar </th>
                    <td mat-cell class="mat-cell" *matCellDef="let element"> {{element?.cultivar ?? '-'}} </td>
                </ng-container>

                <ng-container matColumnDef="blank">
                    <th mat-header-cell *matHeaderCellDef>  </th>
                    <td mat-cell class="mat-cell" *matCellDef="let element">  </td>
                </ng-container>

                <ng-container matColumnDef="nitrogen">
                    <th mat-header-cell *matHeaderCellDef class="analysis-cell-header recommendations-manager-top-left-cell">
                        <div class="div-col">
                            <span style="font-weight: 700">N</span>
                            <span style="text-transform: lowercase">%</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element"  [ngClass]="{'high-value': nValues[i]?.level === 'High', 'low-value': nValues[i]?.level === 'Low', 'normal-value': nValues[i]?.level === 'Normal'}">
                                {{nValues[i]?.value?.length > 0 ? nValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{nValues[i]?.norms?.length > 0 ? nValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="phosphorus">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">P</span>
                            <span style="text-transform: lowercase">%</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element"  [ngClass]="{'high-value': pValues[i]?.level === 'High', 'low-value': pValues[i]?.level === 'Low', 'normal-value': pValues[i]?.level === 'Normal'}">
                                {{pValues[i]?.value?.length > 0 ? pValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{pValues[i]?.norms?.length > 0 ? pValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="potassium">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">K</span>
                            <span style="text-transform: lowercase">%</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element"  [ngClass]="{'high-value': kValues[i]?.level === 'High', 'low-value': kValues[i]?.level === 'Low', 'normal-value': kValues[i]?.level === 'Normal'}">
                                {{kValues[i]?.value?.length > 0 ? kValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{kValues[i]?.norms?.length > 0 ? kValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="calcium">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">Ca</span>
                            <span style="text-transform: lowercase">%</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'high-value': caValues[i]?.level === 'High', 'low-value': caValues[i]?.level === 'Low', 'normal-value': caValues[i]?.level === 'Normal'}">
                                {{caValues[i]?.value?.length > 0 ? caValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{caValues[i]?.norms?.length > 0 ? caValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="magnesium">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">Mg</span>
                            <span style="text-transform: lowercase">%</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'high-value': mgValues[i]?.level === 'High', 'low-value': mgValues[i]?.level === 'Low', 'normal-value': mgValues[i]?.level === 'Normal'}">
                                {{mgValues[i]?.value?.length > 0 ? mgValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{mgValues[i]?.norms?.length > 0 ? mgValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="sodium">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">Na</span>
                            <span style="text-transform: lowercase">mg/kg</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'low-value': naValues[i]?.level === 'High', 'normal-value': naValues[i]?.level === 'Normal' || naValues[i]?.level === 'Low'}">
                                {{naValues[i]?.value?.length > 0 ? naValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{naValues[i]?.norms?.length > 0 ? naValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="sulfur">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">S</span>
                            <span style="text-transform: lowercase">%</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'high-value': sValues[i]?.level === 'High', 'low-value': sValues[i]?.level === 'Low', 'normal-value': sValues[i]?.level === 'Normal'}">
                                {{sValues[i]?.value?.length > 0 ? sValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{sValues[i]?.norms?.length > 0 ? sValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

<!--                <ng-container matColumnDef="chlorine">-->
<!--                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>-->
<!--                        <div class="div-col">-->
<!--                            <span style="font-weight: 700">Cl</span>-->
<!--                            <span style="text-transform: lowercase">mg/kg</span>-->
<!--                        </div>-->
<!--                    </th>-->
<!--                    <td mat-cell *matCellDef="let element; let i = index">-->
<!--                        <div class="analysis-element" *ngIf="element?.keyValues?.length > 0" [ngClass]="{'high-value': clValues[i]?.level === 'High', 'low-value': clValues[i]?.level === 'Low', 'normal-value': moValues[i]?.level === 'Normal'}">-->
<!--                            {{clValues[i]?.value?.length > 0 ? clValues[i].value : '-'}}-->
<!--                        </div>-->

<!--                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">-->
<!--                            - -->
<!--                        </div>-->
<!--                    </td>-->
<!--                </ng-container>-->

                <!--                <ng-container matColumnDef="chlorine">-->
                <!--                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>-->
                <!--                        <div class="div-col">-->
                <!--                            <span style="font-weight: 700">Cl</span>-->
                <!--                            <span style="text-transform: lowercase">mg/kg</span>-->
                <!--                        </div>-->
                <!--                    </th>-->
                <!--                    <td mat-cell *matCellDef="let element; let i = index">-->
                <!--                        <div class="analysis-element" *ngIf="element?.keyValue?.length > 0" [ngClass]="{'high-value': element?.keyValues[1]?.norm === 'High', 'low-value': element.keyValues[1].norm, 'normal-value': moValues[i]?.level === 'Normal'}">-->
                <!--                            {{element?.keyValues[1]?.value.length > 0 ? element.keyValues[1].value : '-'}}-->
                <!--                        </div>-->
                <!--                    </td>-->
                <!--                </ng-container>-->

                <ng-container matColumnDef="copper">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">Cu</span>
                            <span style="text-transform: lowercase">mg/kg</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'high-value': cuValues[i]?.level === 'High', 'low-value': cuValues[i]?.level === 'Low', 'normal-value': cuValues[i]?.level === 'Normal'}">
                                {{cuValues[i]?.value?.length > 0 ? cuValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{cuValues[i]?.norms?.length > 0 ? cuValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="zinc">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">Zn</span>
                            <span style="text-transform: lowercase">mg/kg</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'high-value': znValues[i]?.level === 'High', 'low-value': znValues[i]?.level === 'Low', 'normal-value': znValues[i]?.level === 'Normal'}">
                                {{znValues[i]?.value?.length > 0 ? znValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{znValues[i]?.norms?.length > 0 ? znValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="manganese">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">Mn</span>
                            <span style="text-transform: lowercase">mg/kg</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'high-value': mnValues[i]?.level === 'High', 'low-value': mnValues[i]?.level === 'Low', 'normal-value': mnValues[i]?.level === 'Normal'}">
                                {{mnValues[i]?.value?.length > 0 ? mnValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{mnValues[i]?.norms?.length > 0 ? mnValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="boron">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">B</span>
                            <span style="text-transform: lowercase">mg/kg</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'high-value': bValues[i]?.level === 'High', 'low-value': bValues[i]?.level === 'Low', 'normal-value': bValues[i]?.level === 'Normal'}">
                                {{bValues[i]?.value?.length > 0 ? bValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{bValues[i]?.norms?.length > 0 ? bValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="iron">
                    <th mat-header-cell class="analysis-cell-header" *matHeaderCellDef>
                        <div class="div-col">
                            <span style="font-weight: 700">Fe</span>
                            <span style="text-transform: lowercase">mg/kg</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'high-value': feValues[i]?.level === 'High', 'low-value': feValues[i]?.level === 'Low', 'normal-value': feValues[i]?.level === 'Normal'}">
                                {{feValues[i]?.value?.length > 0 ? feValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{feValues[i]?.norms?.length > 0 ? feValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="molybdenum">
                    <th mat-header-cell *matHeaderCellDef class="analysis-cell-header samples-top-right-cell">
                        <div class="div-col">
                            <span style="font-weight: 700">Mo</span>
                            <span style="text-transform: lowercase">mg/kg</span>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element; let i = index">
                        <div class="element-container" *ngIf="element?.keyValues?.length > 0" >
                            <div class="analysis-element" [ngClass]="{'high-value': moValues[i]?.level === 'High', 'low-value': moValues[i]?.level === 'Low', 'normal-value': moValues[i]?.level === 'Normal'}">
                                {{moValues[i]?.value?.length > 0 ? moValues[i].value : '-'}}
                            </div>
                            <span *ngIf="showNorm">{{moValues[i]?.norms?.length > 0 ? moValues[i].norms : ''}}</span>
                        </div>

                        <div *ngIf="!element?.keyValues || element?.keyValues?.length === 0">
                            -
                        </div>
                    </td>
                </ng-container>

<!--                <ng-container matColumnDef="action">-->
<!--                    <th mat-header-cell *matHeaderCellDef class="analysis-cell-header samples-top-right-cell"></th>-->
<!--                    <td mat-cell style="text-align: right !important;" *matCellDef="let element">-->
<!--                        <div class="remove-sample-button">-->
<!--                            <img src="../../assets/icons/delete.svg" alt="Delete Icon" class="remove-sample-icon">-->
<!--                        </div>-->
<!--                    </td>-->
<!--                </ng-container>-->

                <tr mat-header-row *matHeaderRowDef="sampleColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row;let i = index; columns: sampleColumns;"></tr>
            </table>
        </div>
    </div>

    <div class="bottom-bar-container">
        <div class="flex flex-row items-center gap-2.5 text-[11px]">
            <div class="flex items-center gap-1">
                <span class="font-semibold mr-1">*Table Legion:</span>
                <span class="py-0.5 px-1.5 rounded text-[10px] font-bold" style="background-color: #FF8228">Low</span>
                <span class="py-0.5 px-1.5 rounded text-[10px] font-bold" style="background-color: #C2CC23">Optimal</span>
                <span class="py-0.5 px-1.5 rounded text-[10px] font-bold" style="background-color: #FFCF01">High</span>
            </div>
            <span class="text-[var(--tertiary-text)]">/</span>
            <div class="flex items-center gap-1">
                <span class="font-semibold mr-1">*Na Legion:</span>
                <span class="py-0.5 px-1.5 rounded text-[10px] font-bold" style="background-color: #C2CC23">Low</span>
                <span class="py-0.5 px-1.5 rounded text-[10px] font-bold" style="background-color: #C2CC23">Optimal</span>
                <span class="py-0.5 px-1.5 rounded text-[10px] font-bold" style="background-color: #FF8228">High</span>
            </div>
        </div>

        <mat-paginator
                (page)="onPaginateChange($event)"
                [pageSize]="pageSize"
                [pageIndex]="currentPage"
                [pageSizeOptions]="[5, 10, 20]"
                [showFirstLastButtons] = "true"
                [length]="totalElements">
        </mat-paginator>
    </div>

    <mat-divider></mat-divider>

    <span class="section-title" style="margin-top: 20px">Report Details</span>

    <div class="div-row" style="gap: 20px">
        <div class="notes-comments-container">
            <div><p class="notes-comments-sub-heading">Recommendation</p></div>
            <textarea [(ngModel)]="note" (ngModelChange)="emitChanges()" class="notes-comments-text-aria" name="notes-comments" rows="4" cols="50" wrap="soft"></textarea>
        </div>

        <div class="notes-comments-container">
            <div><p class="notes-comments-sub-heading">Comments</p></div>
            <textarea [(ngModel)]="comment" (ngModelChange)="emitChanges()" class="notes-comments-text-aria" name="notes-comments" rows="4" cols="50" wrap="soft"></textarea>
        </div>
    </div>
</div>
